import React from 'react';
import { Form, InputNumber } from 'antd';
import { configShort } from '../../../../../common/utils/configFormField';

class Section1 extends React.PureComponent {
  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields, disabledFields } = this.props;
    return (
      <div className="sectionLosses">
        <h1 className="header">
          Убытки, возмещаемые фрахтователем фрахтовщику
        </h1>
        <div className="colsLayout">
          <span className="label">
            Отказ фрахтователя оплачивать
            <br />
            дополнительные платежи (Ш3), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section1_1', configShort(fields['section1_1']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Неоплата фрахтователем цены
            <br />
            договора (Ш3), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section1_2', configShort(fields['section1_2']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Неявка фрахтователя
            <br />
            (всех пасс.) на посадку (Ш3), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section1_3', configShort(fields['section1_3']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Непредоставление фрахтователем
            <br />
            документов для перевозки (Ш3), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section1_4', configShort(fields['section1_4']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Отказ фрахтователя от пользования
            <br />
            предоставленным ТС (Ш3), % от цены договора:
          </span>
          <Form.Item>
            {getFieldDecorator('section1_5', configShort(fields['section1_5']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default Section1;
